import { render, staticRenderFns } from "./edite-league.vue?vue&type=template&id=16b21c6d&scoped=true"
import script from "./edite-league.vue?vue&type=script&lang=js"
export * from "./edite-league.vue?vue&type=script&lang=js"
import style0 from "./edite-league.vue?vue&type=style&index=0&id=16b21c6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b21c6d",
  null
  
)

export default component.exports